import { render, staticRenderFns } from "./tabel-item.vue?vue&type=template&id=51696502&scoped=true&"
import script from "./tabel-item.vue?vue&type=script&lang=js&"
export * from "./tabel-item.vue?vue&type=script&lang=js&"
import style0 from "./tabel-item.vue?vue&type=style&index=0&id=51696502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51696502",
  null
  
)

export default component.exports